<template>
  <div>
    <div style="text-align: left;margin-left: 5px;margin-top: 20px;margin-bottom: 20px;font-size: 15px;">请按顺序点击进行排序：</div>
    <div v-for="(opt, i) in options" :key="i" class="option">
      <span class="xh">{{ opt.xl }}</span>
      <span class="optcon" @click="clickopt(i)" v-html="answer[i]+'.'+opt[showtype]"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xl: 1,
      answer:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
    };
  },
  created() {
    for (let i = 0; i < this.options.length; i++) {
      if (this.xl <= this.options[i].xl) {
        this.xl = this.options[i].xl + 1;
      }
      if (this.options[i].xl == undefined) {
        this.options[i].xl = '';
      }
    }
  },
  model: {
    prop: 'options',
    event: 'paixu'
  },
  props: {
    options: Array,
    showtype: String,
    rkey: String
  },
  methods: {
    clickopt(i) {
      let opt = this.options[i];

      if (opt.xl == '' || opt.xl == undefined) {
        opt.xl = this.xl;
        this.xl++;
      } else if (opt.xl == this.xl - 1) {
        opt.xl = '';
        this.xl--;
      }
      this.$set(this.options, i, opt);
      let ans = [];
      for (let z = 0; z < this.options.length; z++) {
        if(this.options[z].xl){
          let sh=this.options[z].xl-1;

          ans[sh]=this.options[z][this.rkey]
        }

      }

      this.$emit('re_value', ans);
      this.$emit('paixu', this.options);
    }
  }
};
</script>

<style>
.option {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding-top: 1.5rem;
}
.xh {
  margin-left: 2px;
  width: 1.25rem;
  color: red;
  font-size: 1.2rem;
}
.optcon {
  flex: 1;
  font-size: 1.2rem;
  text-align: left;
  margin-left: 0.5rem;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/paixu.vue